import { DataTableHeaderAlign } from '@/components/OverviewTable/types.ts';
import { BaseItemDto, getDefaultActions } from '@/utils/actions';
import { FormMode } from '../forms/types';

export function getDefaultContextMenuActions(item?: BaseItemDto, mode?: FormMode) {
  return getDefaultActions(mode, item);
}

export const globalContextMenuHeaderItemDefinition = {
  key: 'contextMenu' as const,
  title: '',
  sortable: false,
  cellClass: 'text-top text-end',
  align: 'end' as DataTableHeaderAlign,
};
